import { render, staticRenderFns } from "./AndTheWorkIsDone.vue?vue&type=template&id=a3ae853a&"
import script from "./AndTheWorkIsDone.vue?vue&type=script&lang=ts&"
export * from "./AndTheWorkIsDone.vue?vue&type=script&lang=ts&"
import style0 from "./AndTheWorkIsDone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports